<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Buyer's Order Report (Dynamic)</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <div
      class="grid grid-cols-1 gap-x-8 gap-y-4 px-4 py-4 text-sm md:grid-cols-2 lg:gap-x-14 lg:px-8"
    >
      <label
        class="flex h-full w-full flex-col items-start lg:flex-row lg:items-center"
      >
        <p
          class="w-full whitespace-pre-line font-bold md:pr-2 lg:w-1/3"
        >
          Preset
        </p>
        <ng-select
          class="w-full flex-grow lg:w-2/3"
          [(ngModel)]="preset"
          [searchable]="true"
          [addTag]="addPreset"
        >
          <ng-option
            *ngFor="let preset of presetList"
            [value]="preset.Id"
          >
            {{ preset.Name }}
          </ng-option>
        </ng-select>
      </label>
      <div class="mt-2 flex gap-x-1" *ngIf="!showNewPreset">
        <button class="shorter-btn save-btn">
          <fa-icon [icon]="faSave" class="mr-1" /> Save Preset
        </button>
        <button class="shorter-btn delete-btn">
          <fa-icon [icon]="faTrash" class="mr-1" /> Delete Preset
        </button>
      </div>
      <button class="shorter-btn save-btn mt-2" *ngIf="showNewPreset">
        <fa-icon [icon]="faPlus" class="mr-1" /> Add New Preset
      </button>
    </div>
    <app-data-form
      [dataFields]="setForm"
      (updateFields_child)="updateFields($event)"
    />
    <app-data-form
      [dataFields]="reportForm"
      [columns]="-1"
      (updateFields_child)="updateFields($event)"
    />
    <div class="flex w-full items-center px-4 lg:px-8">
      <p class="w-1/10 text-sm font-bold">Condition</p>
      <app-data-form
        [dataFields]="conditionFields"
        (updateFields_child)="updateFields($event)"
        [dataName]="'conditionFields'"
        [columns]="0"
      />
      <button
        class="shorter-btn add-btn w-fit"
        (click)="addCondition()"
      >
        <fa-icon [icon]="faPlus" class="mr-1" /> Add Condition
      </button>
    </div>

    <!-- <div class="mt-4" *ngIf="conditionFormFields.length > 0">
      <app-data-form
        [dataFields]="conditionFormFields"
        [columns]="0"
      />
    </div> -->

    <!-- <button
      class="shorter-btn misc-btn"
      (click)="confirmAddCondition()"
      *ngIf="conditionFormFields.length > 0"
    >
      <fa-icon [icon]="faPlus" class="mr-1" /> Confirm Add
    </button> -->
    <app-data-table
      class="mt-3"
      *ngIf="conditionTableEntries.length > 0"
      [tableHeaders]="conditionTableHeaders"
      [tableEntries]="conditionTableEntries"
      (remove)="removeCondition($event)"
      [pagination]="false"
    ></app-data-table>

    <div class="flex w-full items-center px-4 lg:px-8">
      <p class="w-1/10 text-sm font-bold">Sort By</p>
      <app-data-form
        [dataFields]="sortFields"
        (updateFields_child)="updateFields($event)"
        [columns]="0"
      />
      <button class="shorter-btn add-btn w-fit">
        <fa-icon [icon]="faPlus" class="mr-1" /> Add sorting
      </button>
    </div>
    <!-- <app-data-form [dataFields]="sortFields" />
    <button class="shorter-btn add-btn w-fit">
      <fa-icon [icon]="faPlus" class="mr-1" /> Add sorting
    </button> -->
    <app-data-table
      class="mt-3"
      *ngIf="sortingTableEntries.length > 0"
      [tableHeaders]="sortingTableHeaders"
      [tableEntries]="sortingTableEntries"
      (remove)="removeSorting($event)"
      [pagination]="false"
    ></app-data-table>

    <div class="mt-4">
      <button class="shorter-btn print-btn" (click)="exportReport()">
        <fa-icon [icon]="faPrint" class="mr-1" /> Export
      </button>
    </div>
  </div>
</div>
